// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__GhRDr","formControl":"addForm_formControl__xDEOo","list":"addForm_list__RF2x0","btnWrpper":"addForm_btnWrpper__5UPdP"};